import { WebApi } from '@/services/WebApi'

const state = () => ({
  loadedSignature: false,
  loadingSignature: false,
  signatureCache: null
})

const mutations = {
  setSignature (state, value) {
    state.signatureCache = value
    state.loadedSignature = true
  },
  setLoading (state, value) {
    state.loadingSignature = !!value
  }
}

const actions = {
  fetchSignature ({ commit }, inviteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('ClientOnboardingInvite/' + inviteId + '/Contract/Signature')
        .then(response => {
          commit('setSignature', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  addSignature ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.post('ClientOnboardingInvite/' + inviteId + '/Contract/Signature', payload)
        .then(response => {
          commit('setSignature', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
